exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".unit1b .empty-draggable-box{width:165px;border:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/1/1b/diagram4/diagram4.scss
// module id = 954
// module chunks = 0